export enum TrailerAttachmentActionTypes {
    SET_TRAILER_ATTACHMENTS = "SET_TRAILER_ATTACHMENTS",
    CLEAR_TRAILER_ATTACHMENTS = "CLEAR_TRAILER_ATTACHMENTS"
}